
import { DecodeHtml } from '../../utils/decodeHtml';
import { retrunAssets, returnNotImage } from '../../utils/getAssets';
import Heading from '../heading'
import { PropTypes } from 'prop-types';

const DeanMessage = ({ college }) => {
    const deanImage = college?.deansMessage?.items[0]?.content?.properties?.image != null ? retrunAssets(college?.deansMessage?.items[0]?.content?.properties?.image[0]?.url) : returnNotImage()
    const message =     college?.deansMessage?.items[0]?.content?.properties?.message?.markup

    // const heading = `Empowering Engineers: Nurturing Excellence at the College of Engineering, UNITEN`
    // const paragraph = `Welcome to UNITEN's College of Engineering (COE), the largest within the university. We offer bachelor, master's, and PhD programs, focusing on broad-based fundamentals. Choose a technical area for specialization, including high-demand industry courses and a strong emphasis on soft skills development. Our goal is to shape well-rounded engineers with a commitment to career resilience. Our programs are accredited by MQA and BEM, following the Outcome-Based Education (OBE) model. We seek input from stakeholders, define clear Program Educational Objectives (PEO) and Program Outcomes (PO), and employ a Continual Quality Improvement (CQI) system for ongoing enhancement. Join us for a unique learning experience with dedicated staff.`
    // const info = {
    //     name: "Prof. Ir. Dr. Izham bin Datuk Zainal Abidin",
    //     position: "Dean, College of Engineering (COE) Putrajaya Campus, ",
    //     college: "Universiti Tenaga Nasional"

    // }
    return (
        <div className="flex flex-col justify-center gap-16 p-4 md:px-10 items-center bg-white">
            <div className="flex flex-col  gap-10 container mt-12">
                <div className='grid grid-cols-1 lg:grid-cols-[30%_65%] gap-8 items-start'>
                    <div className='flex items-center justify-center'>
                        <img src={deanImage} alt="Dean" className='w-full max-w-full h-auto rounded object-cover ' />
                    </div>
                    <div className='flex flex-col gap-4'>
                        <Heading name="Dean's Message" color="text-blue-700" />
                        {/* <h1 className="w-auto  text-slate-900 text-3xl md:max-w-[30ch] font-bold capitalize">{heading}</h1>
                        <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal">{paragraph}</p> */}
                        {
                            DecodeHtml({html:message})
                        }
                        {/* <div className='flex flex-col gap-2'>
                            <p className="w-auto  text-sky-950  text-base font-normal leading-normal">{info.name}</p>
                            <p className="w-auto  text-sky-950  text-base font-normal leading-normal">{info.position}</p>
                            <p className="w-auto  text-sky-950  text-base font-normal leading-normal">{info.college}</p>
                        </div> */}
                    </div>
                </div>
            </div>

        </div>
    )
}
DeanMessage.propTypes = {
    college: PropTypes.string
}
export default DeanMessage